import { render, staticRenderFns } from "./workStart2.vue?vue&type=template&id=964c2fa4&scoped=true&"
import script from "./workStart2.vue?vue&type=script&lang=js&"
export * from "./workStart2.vue?vue&type=script&lang=js&"
import style0 from "./workStart2.vue?vue&type=style&index=0&id=964c2fa4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964c2fa4",
  null
  
)

export default component.exports